<!-- Página 1: Mantenimiento.vue -->
<template>
  <div class="maintenance-page">
    <div class="maintenance-container">
      <div class="maintenance-icon">🔧</div>
      <h1 class="maintenance-title">Esta web está en mantenimiento</h1>
      <p class="maintenance-description">
        Estamos trabajando para mejorar tu experiencia. Por favor, vuelve pronto.
      </p>
      <button class="back-button" @click="goBack">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
        </svg>
        Volver
      </button>
    </div>
  </div>
</template>

<script setup>
const goBack = () => {
  window.history.back();
};
</script>

<style scoped>
.maintenance-page {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.maintenance-container {
  max-width: 500px;
  padding: 2rem;
  border-radius: 12px;
  background-color: var(--color-surface);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.maintenance-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
}

.maintenance-title {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: var(--color-text-primary);
}

.maintenance-description {
  font-size: 1.1rem;
  color: var(--color-text-secondary);
  margin-bottom: 2rem;
  line-height: 1.6;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--color-primary);
  color: var(--color-text-primary);
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.back-button:hover {
  background-color: var(--color-primary-light);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(92, 141, 246, 0.3);
}

@media (max-width: 768px) {
  .maintenance-title {
    font-size: 1.5rem;
  }

  .maintenance-description {
    font-size: 1rem;
  }
}
</style>
